/* eslint-disable no-param-reassign */
import { createSlice } from '@reduxjs/toolkit';
import { CartItem, CartItemHelper } from '../../React/Data/CartItem';

// Class that represents the data of this store

class CartReducerData {
  cartItems : CartItem[] = [];
}

// Initial State

const initialState : CartReducerData = {
  cartItems: [],
};

// Store definition

// This reducer will manage the cart
// The data that will contain will an array of CartItem objects

export const CartReducer = createSlice({
  name: 'CartReducer',

  initialState,

  reducers: {
    addToCart: (state, action) => {

      // We need to see if there's already an item in the cart with the same characteristics

      const similarItem = state.cartItems.find((cartItem) => {
        return CartItemHelper.AreSimilar(cartItem, action.payload.cartItem);
      });

      // If we found a similar item, just update that quantity
      if (similarItem) {
        const newQuantity = CartItemHelper.GetQuantity(similarItem)
        + CartItemHelper.GetQuantity(action.payload.cartItem);

        CartItemHelper.SetQuantity(similarItem, newQuantity);
      } else {
        state.cartItems.push(action.payload.cartItem);
      }

    },

    changeQuantity: (state, action) => {

      // Find the item
      const existingCartItem = state.cartItems.find((cartItem) => {
        return CartItemHelper.AreSimilar(cartItem, action.payload.cartItem);
      });

      if (existingCartItem) {
        existingCartItem.quantity = action.payload.quantity;
      }
    },

    removeFromCart: (state, action) => {
      state.cartItems = state.cartItems.filter((cartItem) => {
        return !CartItemHelper.AreSimilar(cartItem, action.payload.cartItem);
      });
    },

    clearCart: (state) => {
      state.cartItems = state.cartItems.filter(() => false);
    },
  },
});
